// Generated by CoffeeScript 2.7.0
var LogicalRadioButtonMixin;

export default LogicalRadioButtonMixin = {
  methods: {
    debouncedHandleLogic: function() {
      var option;
      if (this.visible) {
        if (this.logical) {
          this.currentHittedFieldIds = [];
          option = _.first(this.value);
          if (option) {
            return _.each(this.field.logic_rule, (raw_judgement) => {
              if (Skylark.App.Judgement.validate(option.id, raw_judgement)) {
                return this.currentHittedFieldIds = raw_judgement.field_ids;
              }
            });
          }
        }
      } else {
        return this._clearValue();
      }
    }
  }
};
